module.exports = __webpack_public_path__ + "e5.no2.0369b96e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e5.no2.jpg
// module id = GCre
// module chunks = 0